import React, { useState } from 'react';
import { Button } from 'antd';
import PurchaseListTemplate from '../../../pages/purchase/components/PurchaseListTemplate';
import { PurchaseTabScene, PurchaseInfo } from '../../../types/process/purchase';
import { useDefaultQueryFields } from '../../../pages/purchase/purchase.effect';
import UploadPaymentVoucherModal from './modals/UploadPaymentVoucherModal';

const FinancialPendingList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [uploadOpen, setUploadOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const reloadList = () => setRefreshKey(k => k + 1);
  const queryFields = useDefaultQueryFields(PurchaseTabScene.FinancialPending);

  const handleUploadSuccess = () => {
    setUploadOpen(false);
    reloadList();
  };

  const renderTableActions = (record: PurchaseInfo) => {
    const hasVoucher = !!record.purchase.paymentVoucherNo;
    return (
      <Button 
        type="primary"
        disabled={hasVoucher}
        onClick={() => {
          setSelectedIds([record.purchase.purchaseNo]);
          setUploadOpen(true);
        }}
      >
        {hasVoucher ? '已上传' : '上传凭证'}
      </Button>
    );
  };

  const renderBatchActions = (
    selectedRows: PurchaseInfo[],
    clearSelection: () => void
  ) => {
    return (
      <Button
        type="primary"
        disabled={selectedRows.length < 2}
        onClick={() => {
          setSelectedIds(selectedRows.map(r => r.purchase.purchaseNo));
          setUploadOpen(true);
          // clearSelection can be called after success, or we let the list reload clear it.
        }}
        style={{ 
          background: selectedRows.length < 2 ? undefined : '#155dfc',
        }}
      >
        批量上传支付凭证
      </Button>
    );
  };

  return (
    <>
      <PurchaseListTemplate
        title="待办理列表"
        refreshKey={refreshKey}
        queryFields={queryFields}
        tabScene={PurchaseTabScene.FinancialPending}
        defaultScene={PurchaseTabScene.FinancialPending}
        viewModes={React.useMemo(() => [
          {
            mode: 'table' as const,
            label: '表格页',
            renderActions: renderTableActions,
            renderBatchActions: renderBatchActions,
            showField: 'tab_financial_pending'
          }
        ], [renderTableActions, renderBatchActions])}
      />
      <UploadPaymentVoucherModal
        open={uploadOpen}
        onCancel={() => setUploadOpen(false)}
        selectedCount={selectedIds.length}
        selectedIds={selectedIds}
        onSuccess={handleUploadSuccess}
      />
    </>
  );
};

export default FinancialPendingList;
